var definitionListTerm = 'fx_2d2fb1e5_68urh50';

export { definitionListTerm };
//# sourceMappingURL=definitionListTerm.vanilla.mjs.map
